import { useAppSelector } from "..";

export function useGetFiltersByPage(key: string) {
  return useAppSelector(({ filter }) => {
    const page = filter.pages.find((p) => p.key === key)?.value || "";
    return page;
  });
}
